import styled from 'styled-components';

const StyledNumericIcon = styled.span`
    height: 1em;
    line-height: 1;
`;

export default StyledNumericIcon;
